<template>
    <div class="users-style" v-if="agents.length > 0">
        <b-overlay :show="showoverlay" rounded="sm" class="">
            <b-form @submit.stop.prevent="onSubmit">
                <div class="clearfix row py-2 mb-2 d-flex">
                    <div class="col-md-3 col-sm-12">
                        <b-form-group id="agent-group" label="Select Agent" class="required-field mb-0" label-for="agent_id">
                            <b-form-select id="agent_id" class="dasboard_graph_select" v-model="agent_id" name="agent_id" v-validate="{ required: true }" :state="validateState('agent_id')" aria-describedby="agent_id-feedback" data-vv-as="Select Agent">
                                <option value=''>Select Agent</option>
                                <option v-for='agent in agents' :value='agent.id' :key='agent.id'>{{ agent.name }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback id="agent_id-feedback">{{veeErrors.first('agent_id') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <b-form-group id="fiscal_year-group" label="Select Fiscal Year" class="required-field mb-0" label-for="fiscal_year">
                            <b-form-select id="fiscal_year" class="dasboard_graph_select" v-model="year" name="fiscal_year" v-validate="{ required: true }" :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback" data-vv-as="Select Fiscal Year">
                                <option value=''>Select Fiscal Year</option>
                                <option v-for='fyear in fiscal_years' :value='fyear'>{{ fyear }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback id="fiscal_year-feedback">{{veeErrors.first('fiscal_year') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <b-form-group id="month-group" label="Select Month" class="required-field mb-0" label-for="month">
                            <b-form-select id="month" class="dasboard_graph_select" v-model="month" :options="months" name="month" v-validate="{ required: true }" :state="validateState('month')" aria-describedby="month-feedback" data-vv-as="Select Month"></b-form-select>
                            <b-form-invalid-feedback id="month-feedback">{{veeErrors.first('month') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-3 col-sm-12 text-right">
                        <label class="d-block opacity-0" style="opacity: 0;">button</label>
                        <b-button class="" type="submit" variant="primary" title="Generate Report"><div>Generate Report</div></b-button>
                    </div>
                </div>
            </b-form>
        </b-overlay>
        <div class="row mt-4 no-margin" v-if="show_repot">
            <div class="col-12 px-0 text-right mb-3"><b-button class="" type="submit" variant="primary" title="Generate Report" @click="download_report()"><div>Download Report</div></b-button></div>
            <table class="table">
                <thead>
                    <tr class="table-head">
                        <th scope="col">Count</th>
                        <th scope="col">Company Name</th>
                        <th scope="col">Payroll Month</th>
                        <th scope="col">Payslips</th>
                        <th scope="col">Other Payslips</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(r_data, index) in report_data">
                        <tr class="table-row hover-bg" :key="index" :class="{ 'footer-row' : (report_data.length - 1) == index }">                     
                            <td>{{ r_data.count }}</td>
                            <td>{{ r_data.company_name }}</td>
                            <td>{{ r_data.payroll_month }}</td>
                            <td>{{ r_data.payslips }}</td>
                            <td>{{ r_data.other_payslips }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div> 
    </div>
</template>
<style scoped>
    .table .footer-row td {
        font-weight: 600;
    }
</style>
<script>
    export default{
        
        mounted() {
            
        },
        data(){            
            
            return {               
                
                agents: [],
                fiscal_years: [],
                report_data: [],
                agent_logo: null,                
                agent_name:null,
                agent_id: '',
                year: '',
                month: '',
                months: [                    
                    { text: 'Select Month', value: '' },
                    { text: 'July', value: '7' },
                    { text: 'August', value: '8' },
                    { text: 'September', value: '9' },
                    { text: 'October', value: '10' },
                    { text: 'November', value: '11' },
                    { text: 'December', value: '12' },
                    { text: 'January', value: '1' },
                    { text: 'February', value: '2' },
                    { text: 'March', value: '3' },
                    { text: 'April', value: '4' },
                    { text: 'May', value: '5' },
                    { text: 'June', value: '6' }
                ],
                showoverlay: false,
                show_repot: false,
                
            }
        },
        methods:{
            getAgentData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/list' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.agents = response.data;
                }.bind(this));
            },

            choose_agent: function(name, agent_id)
            {
                this.agent_name = name;
                this.agent_id = agent_id;
            },

            getFiscalYears : function()
            {
                axios.get(this.$api_url+'/get/fiscalyear/list').then(function(response)
                {   
                    this.fiscal_years = response.data;

                }.bind(this));
            },

            onSubmit(e) {
                if (!this.checkNet()) return false;
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();
                    var form_error = null;
                    if (form_error) {
                        this.$bvToast.toast(form_error, { title: 'Error!!!', variant: 'danger', solid: true });
                        return false;
                    }
                    let currentObj = this;
                    
                    let formData = new FormData();
                    
                    formData.append('agent_id', this.agent_id);
                    formData.append('fiscal_year', this.year);
                    formData.append('month', this.month);
                    formData.append('show_repot', 1);
                    
                    axios.post(this.$api_url + '/agent-billing-report', formData)
                        .then(function (response) {
                            this.report_data = response.data;
                            console.log('Agent Billing: '+this.report_data.length);
                            if(this.report_data.length > 0){                                
                                this.show_repot = true;
                            }else{
                                this.$bvToast.toast('No data found for the selected period.', {title: 'Error',variant: 'danger',solid: true});
                            }
                        }.bind(this))
                        .catch(function (error) {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },
            download_report: function()
            {
                let currentObj = this;
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let formData = new FormData();
                
                formData.append('agent_id', this.agent_id);
                formData.append('fiscal_year', this.year);
                formData.append('month', this.month);
                formData.append('show_repot', 0);
                
                axios.post(this.$api_url + '/agent-billing-report', formData, config)
                    .then(function (response) {
                        if(response.data.type =='application/json'){
                            let file = new Blob([response.data], {type: 'application/json'});
                            const cast = Promise.resolve(file.text());
                            cast.then((value) => {
                                let err_obj = JSON.parse(`${value}`);
                                this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});  
                            });
                        }else{
                            this.global_download_file_content(response);
                        }
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            },
        },
        created: function(){
            this.getAgentData();
            this.getFiscalYears();
        }
    }
</script>